import { UploadLogFilterType } from '~/client/graph/types.generated'
import { AttachmentGroupingOption } from '~/client/src/shared/enums/AttachmentsGroupingOption'
import FilterInfo from '~/client/src/shared/stores/substates/FilterInfo'

export default class AttachmentsFiltersSettingState {
  public filterInfoMap: { [key: string]: FilterInfo } = {
    [UploadLogFilterType.Company]: new FilterInfo(
      UploadLogFilterType.Company,
      false,
    ),
    [UploadLogFilterType.Location]: new FilterInfo(
      UploadLogFilterType.Location,
      false,
    ),
    [UploadLogFilterType.Source]: new FilterInfo(
      UploadLogFilterType.Source,
      false,
    ),
    [UploadLogFilterType.Formtype]: new FilterInfo(
      UploadLogFilterType.Formtype,
      false,
    ),
    [UploadLogFilterType.Filetype]: new FilterInfo(
      UploadLogFilterType.Filetype,
      false,
    ),
  }

  public desktopFilterMap: { [key: string]: FilterInfo } = {
    [AttachmentGroupingOption.Date]: new FilterInfo(
      AttachmentGroupingOption.Date,
      false,
    ),
    [AttachmentGroupingOption.Company]: new FilterInfo(
      AttachmentGroupingOption.Company,
      false,
    ),
    [AttachmentGroupingOption.UploadedBy]: new FilterInfo(
      AttachmentGroupingOption.UploadedBy,
      false,
    ),
    [AttachmentGroupingOption.Location]: new FilterInfo(
      AttachmentGroupingOption.Location,
      false,
    ),
    [AttachmentGroupingOption.FormType]: new FilterInfo(
      AttachmentGroupingOption.FormType,
      false,
    ),
    [AttachmentGroupingOption.FileType]: new FilterInfo(
      AttachmentGroupingOption.FileType,
      false,
    ),
    [AttachmentGroupingOption.FileCategory]: new FilterInfo(
      AttachmentGroupingOption.FileCategory,
      false,
    ),
  }
}
